/* /tretmani-kose (/en/hair-treatments, /de/haarbehandlungen)

   The four treatments and their prices come from HAIR.tretmani in
   src/config/prices.mjs, in that order: stem cells, Olaplex, hair botox,
   Quick Repair. Keep the locale array in the same order. */

import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Bredcrumb from '../../HomeMain/Bredcrumb';
import Appointment from '../../HomeMain/Appointment';
import Faq from '../../ui/Faq';
import {
  Section, Heading, P, FeatureList, PriceTable, PriceList, CompareTable, BRAND, INK, sans,
} from '../../ui/blocks';
import { HAIR } from '../../../config/prices.mjs';
import { linkTo } from '../../../i18n/lang.mjs';

const COLOURING = '/farbanje-kose';
const BALAYAGE = '/balayage';

const Main = () => {
  const { t, i18n } = useTranslation();
  const lang = ['sr', 'en', 'de'].includes(i18n.language) ? i18n.language : 'sr';

  const treatments = t('hairTreatments.what.items', { returnObjects: true });
  const which = t('hairTreatments.which', { returnObjects: true });
  const duration = t('hairTreatments.duration.items', { returnObjects: true });
  const faq = t('hairTreatments.faq.items', { returnObjects: true });

  const priceRows = treatments.map((item, i) => ({
    label: item.title,
    price: HAIR.tretmani[i],
  }));

  const linkStyle = {
    display: 'inline-block',
    marginTop: '6px',
    marginRight: '20px',
    fontFamily: sans,
    fontSize: '15px',
    fontWeight: 600,
    color: BRAND,
  };

  return (
    <>
      <Bredcrumb title={t('pages.hairTreatments.title')} subtitle={t('pages.hairTreatments.subtitle')} />

      <Section>
        <P style={{ fontSize: '18px', color: INK, fontWeight: 500 }}>{t('hairTreatments.intro.p1')}</P>
        <P style={{ marginBottom: 0 }}>{t('hairTreatments.intro.p2')}</P>
      </Section>

      <PriceList title={t('hairTreatments.what.heading')}>
        <PriceTable rows={priceRows} />
      </PriceList>

      <Section tinted>
        <FeatureList items={treatments} />
      </Section>

      <Section>
        <Heading>{which.heading}</Heading>
        <CompareTable columns={[which.columns[1]]} rows={which.rows} />
        <P style={{ marginBottom: 0 }}>{which.note}</P>
      </Section>

      <Section tinted>
        <Heading>{t('hairTreatments.duration.heading')}</Heading>
        <FeatureList items={duration} />
      </Section>

      <Section>
        <Heading align="center">{t('hairTreatments.faq.heading')}</Heading>
        <Faq items={faq} />
        <div style={{ textAlign: 'center', marginTop: '28px' }}>
          <Link to={linkTo(COLOURING, lang)} style={linkStyle}>
            {t('hairTreatments.colouringLink')} →
          </Link>
          <Link to={linkTo(BALAYAGE, lang)} style={linkStyle}>
            {t('hairTreatments.balayageLink')} →
          </Link>
        </div>
      </Section>

      {/* Same booking form as /contact, pre-filled with this page's service. */}
      <Appointment defaultService="Tretman kose" />

    </>
  );
};

export default Main;
